import { useQuery } from '@/api/hooks';
import { fetchLocalGovernmentFundIndividualReport } from '../review-sheet/utils/download-fund-owner-for-local-government-report';

export const useLocalGovernmentFundIndividualReport = (id: string) => {
  return useQuery({
    queryKey: ['localGovernmentFundIndividualReport', id],
    queryFn: async () => {
      return await fetchLocalGovernmentFundIndividualReport(id);
    },
    enabled: !!id,
  });
};
